import React, { ReactElement } from "react";
import { gql, useMutation } from "@apollo/client";
import { 
  UpdateMyAppSettingMutationMutation, 
  UpdateMyAppSettingMutationMutationVariables 
} from "../../../schemaTypes";
import { normalizeErrors } from "../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../types/NormalizedErrorMap";

export const updateMyAppSettingMutation = gql`
  mutation UpdateMyAppSettingMutation($input: UpdateMyAppSettingInput!) {
    updateMyAppSetting(input: $input) {
      errors {
        path
        message
      }
      message
    }
  }
`;

interface Props {
  children: (
    data: {
      submitUpdateAppSetting: (
        values: UpdateMyAppSettingMutationMutationVariables
      ) => Promise<{ errors: NormalizedErrorMap | null; message?: string }>;
      loading: boolean;
      error: any;
      message: string | null;
    }
  ) => ReactElement | null;
}

export const UpdateAppSettingController: React.FC<Props> = ({ children }) => {
  const [mutate, { loading, error, data }] = useMutation<
    UpdateMyAppSettingMutationMutation,
    UpdateMyAppSettingMutationMutationVariables
  >(updateMyAppSettingMutation);

  const submitUpdateAppSetting = async (values: UpdateMyAppSettingMutationMutationVariables) => {
    const { data: mutationData } = await mutate({ variables: values });
    const result = mutationData?.updateMyAppSetting;
    const errors = result?.errors ? normalizeErrors(result.errors) : null;
    return {
      errors,
      message: result?.message ?? undefined,
    };
  };

  const message = data?.updateMyAppSetting?.message || null;

  return children({
    submitUpdateAppSetting,
    loading,
    error,
    message,
  });
};
